const data = {

            "jobType": [
            "Full Time",
            "Internship 2 months",
            "Internship 6 months"
        ],

















        "hasLaptop": [
            true,
            false
        ],
        "languagesKnown": [
            "English",
            "Hindi",
            "Bengali",
            "Tamil",
            "Telugu",
            "Marathi",
            "Gujarati",
            "Assamese",
            "Malayalam",
            "Kannada",
            "Punjabi",
            "Urdu",
            "Odia",
            "Others"
        ],
        "hasSmartphone": [
            true,
            false
        ],
        "screeningScores": [
            {
                "activity_id": 124,
                "activity_name": "Introduce Yourself",
                "activity_score": {
                    "minimum": 0.0,
                    "maximum": 100.0,
                    "name": "scoreRange"
                }
            },
            {
                "activity_id": 125,
                "activity_name": "Problem Solving",
                "activity_score": {
                    "minimum": 0.0,
                    "maximum": 100.0,
                    "name": "scoreRange"
                }
            },
            {
                "activity_id": 126,
                "activity_name": "Communication Skills",
                "activity_score": {
                    "minimum": 0.0,
                    "maximum": 100.0,
                    "name": "scoreRange"
                }
            }
        ],
        "gender": [
            "Male",
            "Female",
            "Other"
        ],
        "tenthPercentage": {
            "minimum": 0.0,
            "maximum": 100.0,
            "name": "minMaxTenth"
        },
        "twelfthPercentage": {
            "minimum": 0.0,
            "maximum": 100.0,
            "name": "minMaxTwelfth"
        },
        "gradDegree": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 1,
                    "object_name": "Bachelor of Technology (B.Tech)",
                    "object_string": "Bachelor of Technology (B.Tech)",
                    "object_state": false
                },
                {
                    "object_id": 2,
                    "object_name": "Bachelor of Science (B.Sc.)",
                    "object_string": "Bachelor of Science (B.Sc.)",
                    "object_state": false
                },
                {
                    "object_id": 3,
                    "object_name": "Bachelor of Commerce (B.Com)",
                    "object_string": "Bachelor of Commerce (B.Com)",
                    "object_state": false
                },
                {
                    "object_id": 4,
                    "object_name": "Bachelor of Arts (B.A.)",
                    "object_string": "Bachelor of Arts (B.A.)",
                    "object_state": false
                },
                {
                    "object_id": 12,
                    "object_name": "Others",
                    "object_string": "Others",
                    "object_state": false
                }
            ]
        },
        "gradCgpa": {
            "minimum": 0.0,
            "maximum": 100.0,
            "name": "minMaxGradCgpa"
        },
        "postGradDegree": [
            "MBA",
            "MBA-TM",
            "MBA-TTHM",
            "PhD"
        ],
        "postGradCgpa": {
            "minimum": 0.0,
            "maximum": 100.0,
            "name": "portfolioPostGradDegrees"
        },
        "areaOfInterest": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 1,
                    "object_name": "Sales & Marketing",
                    "object_string": "Sales & Marketing",
                    "object_state": false
                },
                {
                    "object_id": 8,
                    "object_name": "Consulting",
                    "object_string": "Consulting",
                    "object_state": false
                },
                {
                    "object_id": 2,
                    "object_name": "Finance",
                    "object_string": "Finance",
                    "object_state": false
                },
                {
                    "object_id": 6,
                    "object_name": "Human Resources",
                    "object_string": "Human Resources",
                    "object_state": false
                }
            ]
        },
        "workExperience": {
            "minimum": 0.0,
            "maximum": 100.0,
            "name": "minMaxWorkExp"
        },
        "isPlaced": [
            true,
            false
        ],
        "isShortlisted": [
            true,
            false
        ],
        "nativeState": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 14,
                    "object_name": "Karnataka",
                    "object_string": "Karnataka",
                    "object_state": false
                },
                {
                    "object_id": 19,
                    "object_name": "Maharashtra",
                    "object_string": "Maharashtra",
                    "object_state": false
                },
                {
                    "object_id": 24,
                    "object_name": "New Delhi",
                    "object_string": "New Delhi",
                    "object_state": false
                },
                {
                    "object_id": 35,
                    "object_name": "West Bengal",
                    "object_string": "West Bengal",
                    "object_state": false
                }
            ]
        },
        "roleType": [
            "Full Time",
            "Internship 2 months",
            "Internship 6 months"
        ],
        "collegeType": [
            "All",
            "NIRF Top 25",
            "NIRF Top 50",
            "NIRF Top 100"
        ],
        "jobIdDetails": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 609,
                    "object_name": "Summer Intern",
                    "object_string": "Summer Intern",
                    "object_state": false
                },
                {
                    "object_id": 6985,
                    "object_name": "Developer",
                    "object_string": "Developer",
                    "object_state": false
                },
                {
                    "object_id": 6988,
                    "object_name": "Customer Success Specialist",
                    "object_string": "Customer Success Specialist",
                    "object_state": false
                },
                {
                    "object_id": 6989,
                    "object_name": "Product Manager Intern",
                    "object_string": "Product Manager Intern",
                    "object_state": false
                },
                {
                    "object_id": 6987,
                    "object_name": "Product Manager",
                    "object_string": "Product Manager",
                    "object_state": false
                },
                {
                    "object_id": 6986,
                    "object_name": "Customer Success Specialist",
                    "object_string": "Customer Success Specialist",
                    "object_state": false
                },
                {
                    "object_id": 6992,
                    "object_name": "Final Placement",
                    "object_string": "Final Placement",
                    "object_state": false
                }
            ]
        },
        "postGradCollege": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 1,
                    "object_name": "Indian Institute of Management Sirmaur",
                    "object_string": "Indian Institute of Management Sirmaur",
                    "object_state": false
                },
                {
                    "object_id": 2,
                    "object_name": "Vedica Scholars Programme for Women",
                    "object_string": "Vedica Scholars Programme for Women",
                    "object_state": false
                },
                {
                    "object_id": 3,
                    "object_name": "FORE Academy of Management Education",
                    "object_string": "FORE Academy of Management Education",
                    "object_state": false
                }
            ]
        },
        "postGradSpecialization": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 6,
                    "object_name": "Others",
                    "object_string": "Others",
                    "object_state": false
                },
                {
                    "object_id": 1,
                    "object_name": "Finance",
                    "object_string": "Finance",
                    "object_state": false
                },
                {
                    "object_id": 2,
                    "object_name": "Sales & Marketing",
                    "object_string": "Sales & Marketing",
                    "object_state": false
                },
                {
                    "object_id": 3,
                    "object_name": "Human Resources",
                    "object_string": "Human Resources",
                    "object_state": false
                }
            ]
        },
        "undergradCollege": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 4,
                    "object_name": "Indian Institute of Technology Delhi",
                    "object_string": "Indian Institute of Technology Delhi",
                    "object_state": false
                },
                {
                    "object_id": 5,
                    "object_name": "Indian Institute of Technology Bombay",
                    "object_string": "Indian Institute of Technology Bombay",
                    "object_state": false
                },
                {
                    "object_id": 3,
                    "object_name": "Indian Institute of Technology Madras",
                    "object_string": "Indian Institute of Technology Madras",
                    "object_state": false
                },
                {
                    "object_id": 7,
                    "object_name": "Indian Institute of Technology Kharagpur",
                    "object_string": "Indian Institute of Technology Kharagpur",
                    "object_state": false
                }
            ]
        },
        "underGradSpecialization": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 1,
                    "object_name": "Computer Science",
                    "object_string": "Computer Science",
                    "object_state": false
                },
                {
                    "object_id": 3,
                    "object_name": "Mechanical Engineering",
                    "object_string": "Mechanical Engineering",
                    "object_state": false
                },
                {
                    "object_id": 8,
                    "object_name": "Economics",
                    "object_string": "Economics",
                    "object_state": false
                },
                {
                    "object_id": 9,
                    "object_name": "Commerce",
                    "object_string": "Commerce",
                    "object_state": false
                }
            ]
        },
        "lastWorkexDomain": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 1,
                    "object_name": "Software Engineering",
                    "object_string": "Software Engineering",
                    "object_state": false
                },
                {
                    "object_id": 2,
                    "object_name": "Finance",
                    "object_string": "Finance",
                    "object_state": false
                },
                {
                    "object_id": 4,
                    "object_name": "Sales Marketing",
                    "object_string": "Sales Marketing",
                    "object_state": false
                },
                {
                    "object_id": 6,
                    "object_name": "Consulting",
                    "object_string": "Consulting",
                    "object_state": false
                },
                {
                    "object_id": 7,
                    "object_name": "Others",
                    "object_string": "Others",
                    "object_state": false
                }
            ]
        },
        "lastWorkexIndustry": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 1,
                    "object_name": "Technology",
                    "object_string": "Technology",
                    "object_state": false
                },
                {
                    "object_id": 2,
                    "object_name": "Financial Services",
                    "object_string": "Financial Services",
                    "object_state": false
                },
                {
                    "object_id": 8,
                    "object_name": "Others",
                    "object_string": "Others",
                    "object_state": false
                },
                {
                    "object_id": 10,
                    "object_name": "E-commerce",
                    "object_string": "E-commerce",
                    "object_state": false
                },
                {
                    "object_id": 7,
                    "object_name": "Telecommunications",
                    "object_string": "Telecommunications",
                    "object_state": false
                }
            ]
        },
        "lastCTC": {
            "minimum": 3.0,
            "maximum": 100.0,
            "name": "minMaxLastCTC"
        },
        "expectedCTC": {
            "minimum": 3.0,
            "maximum": 100.0,
            "name": "minMaxExpectedCTC"
        },
        "homeCity": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 135,
                    "object_name": "Bengaluru. Karnataka. India",
                    "object_string": "Bengaluru",
                    "object_state": false
                },
                {
                    "object_id": 448,
                    "object_name": "Hyderabad. Telangana. India",
                    "object_string": "Hyderabad",
                    "object_state": false
                },
                {
                    "object_id": 776,
                    "object_name": "Muzaffarpur. Bihar. India",
                    "object_string": "Muzaffarpur",
                    "object_state": false
                },
                {
                    "object_id": 820,
                    "object_name": "New Delhi. New Delhi. India",
                    "object_string": "New Delhi",
                    "object_state": false
                }
            ]
        },
        "locationsOpenTo": {
            "allow_search": true,
            "object_details": [
                {
                    "object_id": 135,
                    "object_name": "Bengaluru. Karnataka. India",
                    "object_string": "Bengaluru",
                    "object_state": false
                },
                {
                    "object_id": 448,
                    "object_name": "Hyderabad. Telangana. India",
                    "object_string": "Hyderabad",
                    "object_state": false
                },
                {
                    "object_id": 776,
                    "object_name": "Muzaffarpur. Bihar. India",
                    "object_string": "Muzaffarpur",
                    "object_state": false
                },
                {
                    "object_id": 820,
                    "object_name": "New Delhi. New Delhi. India",
                    "object_string": "New Delhi",
                    "object_state": false
                }
            ]
        },
        "availableFrom": [
            1761955200000,
            1764547200000,
            1767225600000,
            1769904000000,
            1772323200000,
            1775001600000,
            1777593600000,
            1780272000000,
            1782864000000,
            1785542400000
        ],
        "hasDrivingLicense": [
            true,
            false
        ],
        "hasTwoWheeler": [
            true,
            false
        ]
    }

export default data;